// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__2KJPI","reservationColumn":"Table_reservationColumn__1oDjc"};